import styled from "@emotion/styled";
import {
  Checkbox,
  Refresh,
  Text,
  XIcon,
} from "@totalenergiescode/mobility-business-rev-design-system";

export const StyledContainer = styled("div")`
  font-family: Arial, sans-serif;
  margin: 20px;

  // WARNING: This is mandatory since it's not applied by default in the reset css
  & * {
    box-sizing: border-box;
  }
`;

export const StyledDaysContainer = styled("div")`
  display: flex;
  flex-flow: row wrap;
  gap: 8px;
  margin: 15px 0;
`;

export const StyledDayLabel = styled("label")`
  display: inline-flex;
  align-items: center;
  height: 40px;
  padding: 8px 12px;

  background-color: ${({ theme }) => theme.palette.background.default};
  color: ${({ theme }) => theme.palette.grey[500]};

  font-size: 14px;
  font-weight: bold;
  border-radius: 10px;
  border: 1px solid ${({ theme }) => theme.palette.grey[200]};
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.palette.grey[100]};
    color: ${({ theme }) => theme.palette.grey[900]};
  }

  &:has(input:checked) {
    ${({ theme }) =>
      `
      border-color: ${theme.palette.avatar.red};
      color: ${theme.palette.grey[900]};
    `}
  }

  &:has(input:disabled) {
    cursor: not-allowed;
  }
`;

export const StyledCheckbox = styled(Checkbox)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(calc(-50% + 5px), -50%);
`;

export const StyledXIcon = styled(XIcon)`
  color: ${({ theme }) => theme.palette.avatar.red};
`;

export const StyledRefreshIcon = styled(Refresh)`
  color: ${({ theme }) => theme.palette.avatar.mainBlue};
`;

export const StyledBlock = styled("div")`
  display: flex;
  position: relative;
  margin-left: 10px;
  width: 20px;
  height: 100%;
`;

export const StyledErrorText = styled(Text)`
  color: ${({ theme }) => theme.palette.danger.danger[500]};
  margin-bottom: 8px;
`;
